import SideNavigation, { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import { useCapabilities } from '../capabilities';
import { navigate, settingsPath, uploadPath, usePath } from '../router';

export function navItems(canCreate: boolean): SideNavigationProps.Item[] {
  const items: SideNavigationProps.Item[] = [
    { type: 'link', text: 'Reports', href: '/' },
  ];
  if (canCreate) {
    items.push({
      type: 'section',
      text: 'Upload',
      items: [{ type: 'link', text: 'Upload report', href: uploadPath() }],
    });
  }
  items.push({
    type: 'section',
    text: 'Preferences',
    items: [{ type: 'link', text: 'Email preferences', href: settingsPath() }],
  });
  return items;
}

/** The href the side nav highlights for the current route. */
export function activeHref(path: string): string {
  if (path === settingsPath()) return settingsPath();
  if (path === uploadPath()) return uploadPath();
  return '/';
}

export function SideNav() {
  const path = usePath();
  const { canCreate } = useCapabilities();
  return (
    <SideNavigation
      header={{ href: '/', text: 'SENTRIA' }}
      activeHref={activeHref(path)}
      items={navItems(Boolean(canCreate))}
      onFollow={(event) => {
        if (event.detail.external) return;
        event.preventDefault();
        navigate(event.detail.href);
      }}
    />
  );
}
